import { DateLocale } from '@/i18n/models/DateLocale';
import type { IntlDateTimeFormats } from 'vue-i18n';

export const datetimeFormats: IntlDateTimeFormats = {
  [DateLocale.NL]: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  },
  [DateLocale.EN]: {
    short: {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    },
    long: {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    }
  }
};
